import { Type, BookMarked, Hash, Calendar, Banknote, List, CheckSquare, FileText } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** Formats de champ (spec iter152 P2) — icône lucide colorée + libellé, partagé par tous les modes. */
export const FIELD_TYPE_META = {
  text:        { label: "Texte",            Icon: Type,        color: "#5B9EE8" },
  text_memory: { label: "Texte (mémoire)",  Icon: BookMarked,  color: "#F87171" },
  number:      { label: "Nombre",           Icon: Hash,        color: "#5B9EE8" },
  date:        { label: "Date",             Icon: Calendar,    color: "#37c99a" },
  money:       { label: "Montant (DA)",     Icon: Banknote,    color: "#e6c383" },
  dropdown:    { label: "Liste déroulante", Icon: List,        color: "#a3a6ec" },
  checkbox:    { label: "Case à cocher",    Icon: CheckSquare, color: "#a3a6ec" },
  file:        { label: "Fichier",          Icon: FileText,    color: "#9CA3AF" },
};
export const FIELD_TYPE_ORDER = ["text", "text_memory", "number", "date", "money", "dropdown", "checkbox", "file"];

export function FieldTypeOption({ type }) {
  const m = FIELD_TYPE_META[type] || FIELD_TYPE_META.text;
  return <span className="inline-flex items-center gap-2"><m.Icon size={13} strokeWidth={2} style={{ color: m.color, flexShrink: 0 }} />{m.label}</span>;
}

export default function FieldTypeSelect({ value, onChange, disabled = false, excludeTypes = [], className = "h-8", style, testId }) {
  const types = FIELD_TYPE_ORDER.filter((t) => !excludeTypes.includes(t) && !excludeTypes.includes(t === "file" ? "fichier" : t));
  return (
    <Select value={value || "text"} onValueChange={(v) => !disabled && onChange?.(v)} disabled={disabled}>
      <SelectTrigger className={className} data-testid={testId} style={{ background: "#1B1B1B", ...style }}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {types.map((t) => <SelectItem key={t} value={t} data-testid={testId ? `${testId}-opt-${t}` : undefined}><FieldTypeOption type={t} /></SelectItem>)}
      </SelectContent>
    </Select>
  );
}
